import MicroModal from 'micromodal';

document.addEventListener('DOMContentLoaded', function () {
  MicroModal.init({
    awaitOpenAnimation: true,
    awaitCloseAnimation: true,
    disableScroll: true,
  });
});
